export default {
sets: `Conjuntos`,
stats: `Estadísticas`,
discover: `Descubrir`,
guides: `Guías`,
settings: `Ajustes`,
unsupportedBrowserBody: `Flashcards does not support this browser. Download the latest version of Chrome or Opera, or download our iPhone, or Android Application`,
unsupportedBrowserTitle: `Navegador no soportado`,
noData: `No hay datos para mostrar`,
contactUsTitle: `Nos encanta escuchar cómo nuestros usuarios usan nuestra aplicación y cómo podemos mejorar. Soltarnos un mensaje con cualquier consulta, como solicitudes de características o informes de errores`,
rateAppStore: `Tarifa en AppStore`,
rateGoogle: `Tarifa en Google Play`,
close: `Cerrar`,
shareFriends: `Compartir con amigos`,
noCardsQ: `¿No tienes ninguna flashcards?`,
noCardsS: `Seleccione de nuestra colección para comenzar`,
suggestSet: `Sugerir conjunto`,
createOwn: `Crea tu propio`,
search: `Buscar`,
loading: `Cargando`,
words: `Palabras`,
downloads: `Descargas`,
export: `Exportación`,
import: `Importar`,
importing: `Importando ... no cierres la aplicación`,
importPreview: `Vista previa de importación`,
howQuizlet: `Cómo importar desde Quizlet`,
cards: `Tarjetas`,
importPreviewStatus: `Los términos __ están listos para ser adjuntos a las tarjetas de ___ existentes`,
importPaste: `Pegue sus tarjetas en la textarea anterior`,
setTotalLimitReached: `Solo puedes tener 3000 tarjetas en un StudySet`,
studying: `Estudiando`,
learnt: `Aprendió`,
mastered: `Dominado`,
new: `Nuevo`,
noTerm: `Ningún término`,
noDef: `Sin definición`,
cardSaved: `Tarjeta guardada`,
reviews: `Comentarios`,
practices: `Prácticas`,
flashcards: `Flashcards`,
alerts: `Alertas`,
corrects: `Corrige`,
mistakes: `Errores`,
reviewCycle: `Ciclo de revisión`,
reviewsLeft: `Reseñas izquierda`,
lastReview: `Última revisión`,
nextReview: `Revisión siguiente`,
hideHistory: `Ocultar historia completa`,
showHistory: `Mostrar historia completa`,
strength: `Fuerza`,
star: `Estrella`,
image: `Imagen`,
tag: `Etiqueta`,
added: `adicional`,
removed: `remoto`,
reviewedFrom: `Revisado desde __`,
notifications: `Notificaciones`,
reviewedPractice: `Revisado __ por ___ Practica`,
successfully: `exitosamente`,
unsuccessfully: `sin éxito`,
termUpdated: `Término actualizado`,
defUpdated: `Definición actualizada`,
flashcardCreated: `Flashcard creado`,
dropboxImage: `Tienes que habilitar a Dropbox para agregar imágenes`,
deleteImgConfirm: `¿Estás seguro de que quieres eliminar esta imagen?`,
uploading: `Cargar`,
save: `Ahorrar`,
uploadImageFail: `Error al subir la imagen`,
imageUploaded: `Imagen subida`,
setNotFound: `StudySet no encontrado!`,
notEnoughCards: `¡No hay cartas suficientes!`,
of: `__ / ___`,
on: `Sobre`,
off: `Apagado`,
auto: `Automático`,
manual: `Manual`,
pronounce: `Pronunciar`,
practiceCompleted: `Has completado esta práctica.`,
closePractice: `Práctica cercana`,
autoplay: `Auto-reproducción`,
secFlipSecNext: `__ Sec Flip, ___ Sec Siguiete`,
autopronounce: `Autopronice`,
onlyTerm: `Solo término`,
onlyDef: `Solo definición`,
termAndDef: `Término y definición`,
savePractice: `Guardar la práctica?`,
continueLater: `Continuar luego`,
deletePractice: `Eliminar la práctica`,
term: `Término`,
def: `Definición`,
monA: `L`,
tueA: `M`,
wedA: `M`,
thuA: `J`,
friA: `V`,
satA: `S`,
sunA: `D`,
reviewGoal: `Objetivo de revisión`,
dailyGoal: `Obj. diario`,
edit: `Editar`,
setUp: `Configurar`,
noRecentPractice: `No tienes prácticas recientes.`,
continueLastReview: `Continuar la última revisión`,
dueCards: `Tarjetas debidas`,
studyNow: `Estudia ahora`,
newCards: `Nuevas tarjetas`,
terms: `condiciones`,
defs: `definiciones`,
validCardsOf: `Solo se pueden practicar __ de las tarjetas seleccionadas de ___, ya que los otros están perdiendo el término o la definición`,
reviewCards: `Tarjetas de revisión`,
customizePractice: `Personalizar la práctica`,
next: `Próximo`,
iWasRight: `Yo tenía razón`,
printProAlert: `Por favor, compre la suscripción Pro para imprimir más de 20 flashcards`,
print: `Impresión`,
printWidth: `Ancho de término de definición`,
printFont: `Tamaño de fuente`,
printBorder: `Frontera`,
printMargin: `Margen de página`,
printPadding: `Relleno de palabras`,
preparingFile: `Preparando archivo`,
notificationsBlocked: `Las notificaciones no están habilitadas, habilita las notificaciones de la configuración de su teléfono`,
ranOutOfWords: `Se quedó sin tarjetas, reinicie la práctica para comenzar`,
ranOutOfWordsShort: `Quedarse sin palabras`,
ranOutOfWordsBody: `Abra la aplicación para programar nuevas palabras`,
proIncreaseNotifications: `Puede aumentar las notificaciones totales de 10 a 50 en la versión Premium.`,
schedule: `Calendario`,
frequency: `Frecuencia`,
mode: `Modo`,
tM1: `1 minuto`,
tM2: `2 minutos`,
tM5: `5 minutos`,
tM10: `10 minutos`,
tM15: `15 minutos`,
tM30: `30 minutos`,
tH1: `1 hora`,
tH2: `2 horas`,
termPassive: `Término pasivo`,
termActive: `Término activo`,
defPassive: `Def pasivo`,
defActive: `Def activo`,
scheduledIn: `Programado en __ mins`,
scheduledAlertsProT: `Aumentar las alertas programables con PRO`,
scheduledAlertsProB: `Puede aumentar las alertas programadas de 10 a 50 con el paquete PRO`,
seeFeatures: `Ver características`,
defAndTerm: `Definición y término`,
termHoldDef: `Término, espera para revelar definición`,
defHoldTerm: `Definición, sostenga para revelar el término`,
notificationType: `Tipo de notificación`,
copyToClipboard: `Copiar al portapapeles`,
enterAuthCode: `Por favor ingrese su código de autorización`,
invalidCode: `Código inválido proporcionado`,
copied: `¡Copiado!`,
promoH2: `Flashcard Manager Pro`,
promoP: `Obtenga más eficiencia en su propio ritmo con las características premium y las ideas avanzadas`,
promoBtn: `Descubre todas las características`,
setDropboxH2: `Sincronización de Dropbox`,
setDropboxPOff: `Habilite Dropbox Sync para mantener sus conjuntos, tarjetas de flash, etiquetas y progreso respaldados y actualizados en todos sus dispositivos.`,
setDropboxPOn: `Sus datos están respaldados y sincronizados en sus dispositivos.`,
setDropboxBtn: `Sincronizar`,
status: `Estado`,
syncNow: `Sincronizar ahora`,
contact: `Contacto`,
contactUs: `Contáctenos`,
useFromBrowser: `Usar desde el navegador`,
useFromBrowserMsg: `Visite flashcardsmadesimple.com en su computadora y restaure sus tarjetas y licencia al habilitar Dropbox Sync`,
termsPrivacy: `Términos y privacidad`,
dailyReviewGoal: `Objetivo de revisión diaria`,
numberTerms: `Número de términos`,
selectTerm: `Seleccione con la pista de términos`,
selectDef: `Seleccione con la definición de sugerencia`,
pronounceTerm: `Pronuncia con pista de plazo`,
pronounceDef: `Pronuncia con la definición de sugerencia`,
typeTerm: `Tipo con pista a plazo`,
typeDef: `Escriba con sugerencia de definición`,
quizTypes: `Tipos de prueba preferidos`,
spacedRepetition: `Horario de repetición espaciado`,
spacedRepetitionP: `La repetición espaciada le permite dominar las palabras con menos esfuerzos al espaciar incrementalmente el tiempo de revisión. El horario predeterminado es de 1-3-7-15-31 días, pero también puede configurar una personalizada.`,
spacedRepetionScheduleItem: `__ Días después de ___ Opinión (Día ____)`,
atLeastOneSchedule: `Se requiere al menos un horario`,
revisionLimitReached: `Llegaste al máximo recuento de revsion`,
addReviewSchedule: `Añadir nuevo horario de revisión`,
autoMarkLearnt: `Mark automático aprendió después`,
autoMarkMastered: `Mark automático dominado después de`,
tagManager: `Administrador de etiquetas`,
delete: `Borrar`,
addTag: `Añadir nueva etiqueta`,
tagDeletionH: `Eliminación de la etiqueta`,
tagDeletionP: `¿Estás seguro de que quieres eliminar esta etiqueta?`,
cancel: `Cancelar`,
daysAfterLastReview: `Días después de la última revisión.`,
linkDropbox: `Enlace Dropbox`,
startSync: `Sincronización de sincronización`,
starred: `Sembrado de estrellas`,
images: `Imagenes`,
tags: `Etiquetas`,
types: `Tipos`,
activeDays: `Días activos`,
inactiveDays: `Días inactivos`,
longestStreak: `Racha más larga`,
dailyGoalsCompleted: `Objetivos diarios completados`,
dailyGoalsFailed: `Las metas diarias fallaron`,
typePairs: `Tipo de pares`,
reviewTypes: `Tipos de revisión`,
typePractice: `Práctica de tipo`,
pronouncePractice: `Pronuncia práctica`,
selectPractice: `Seleccione la práctica`,
notificationReview: `Revisión de notificaciones`,
flashcardReview: `Revisión de Flashcard`,
studyset: `Estudiante de estudio`,
enterStudysetName: `Por favor ingrese un nombre para su conjuntos`,
studysetName: `Ingrese el nombre del conjunto`,
termType: `Tipo de término / Idioma`,
defType: `Tipo de definición / Idioma`,
exportCards: `Tarjetas de exportación`,
importCards: `Tarjetas de importación`,
quiz: `Examen`,
showingOutOfCards: `Mostrando __ de ___ tarjetas`,
showingAllCards: `Mostrando todas tarjetas`,
recording: `Grabación`,
downloadSet: `Acordgar es mis conjuntos`,
addNewCard: `Añadir nueva tarjeta`,
saveStudyset: `Guardar conjunto de estudio`,
studysetDeletionH: `Eliminación del conjunto`,
studysetDeletionP: `¿Está seguro de que desea eliminar este StudySet, esto también eliminará todas las tarjetas contenidas?`,
cardDeletionH: `Eliminación de tarjetas`,
cardDeletionP: `¿Está seguro de que desea eliminar esta tarjeta?`,
cardLimitReached: `Solo puedes tener 3000 tarjetas en un StudySet`,
limitExceeded: `Límite excedido`,
atLeastTenCards: `Agregue al menos 10 cartas para comenzar con las prácticas.`,
searchInAll: `Buscar en todos los conjuntos de estudio`,
noMatch: `Sin coincidencia`,
atLeastThreeChars: `Ingrese al menos 3 caracteres para buscar`,
noSets: `Sin sets`,
startingSync: `Sincronización de inicio`,
noSetsP: `Seleccione de las siguientes opciones para comenzar`,
startingSyncP: `Estamos recibiendo sus datos de Dropbox, esto podría tomar un tiempo`,
createNewStudyset: `Crea Nuevo Conjuntos`,
restoreFromBackup: `Restaurar desde el archivo de copia de seguridad`,
setStarterPacks: `Conjuntos Ejemplo`,
selectPracticeType: `Seleccione Tipo de práctica`,
noDueCards: `Aún no hay tarjetas Flashcards, las tarjetas que ha revisado anteriormente comenzará a aparecer aquí después del programa de repetición espaciado seleccionado para ayudarlo a dominar palabras con menos esfuerzo y tiempo`,
noNewCards: `No hay tarjetas nuevas para estudiar.`,
subscriptionH: `Compre Pro para disfrutar de todas las características y para apoyar el desarrollo continuo.`,
buyLifetimePro: `Comprar Lifetime Pro por __`,
restorePurchase: `Restaurar la compra`,
termsPrivacyC: `Política de términos y privacidad`,
licenceShare: `Si compró una licencia de otro dispositivo, puede compartirlo con este dispositivo al habilitar Dropbox Sync en ambos dispositivos`,
enterTagName: `Ingrese el nombre de la etiqueta`,
invalidName: `Nombre inválido`,
create: `Crear`,
name: `Nombre`,
tagName: `Nombre de su etiqueta`,
color: `Color`,
back: `Atrás`,
rowSeparator: `Separador de filas`,
termDefSeparator: `Término - Separador Def`,
output: `Producción`,
inputCards: `Tarjetas de entrada`,
review: `Revisar`,
language: `Idioma`,
archiveReversible: `Archivo (reversible de la configuración)`,
deletePermanent: `Eliminar (irreversible)`,
archivedCards: `Tarjetas Archivadas`,
masteredCards: `Tarjetas masternas`,
due: `Vencer`,
reviewed: `Revisados`,
markReviewed: `Marca revisada`,
markMastered: `Marca masterizada`,
forXYCards: `por __ ___ tarjetas`,
createdAtSortBy: `Fecha de creación`,
lastReviewedSortBy: `Fecha de última revisión`,
reviewCountSortBy: `Número de revisiones`,
strengthSortBy: `Fuerza`,
termSortBy: `Término alfabético`,
definitionSortBy: `Definición alfabético`,
ascSortBy: `Ascendente`,
descSortBy: `Descender`,
featureSync: `Estudia cualquier cosa, en cualquier lugar, en cualquier momento con sus flashcards sincronizados por todos sus dispositivos`,
featureSpacedrepetition: `Mire su progreso general y vuelva a practicar lo que necesita para practicar.`,
featureNotifications: `Superja tu aprendizaje sin siquiera abrir la aplicación con notificaciones flexibles.`,
featureFlashcards: `Flashcards de AutoPlay cuando tus manos u ojos están ocupados, pero todavía tienes atención no utilizada`,
featureQuiz: `Partir, deletrear, escuchar o seleccionar para practicar tus flashcards`,
featureStats: `Obtenga una mejor idea de sus tarjetas y resultados, y busque todos sus conjuntos de Flashcard`,
featureImport: `Nunca guardaremos los datos de usted, y usted puede exportar e importar todos sus datos fácilmente`,
featurePrint: `Obtenga algún aprendizaje hecho imprimiendo sus flashcards, y briegue su propia plataforma de estudio`,
splashIntro: `Estudia todas tus flashcards en cualquier lugar de tu ritmo y estilo.`,
selectSortOrder: `Orden de clasificación`,
selectSortProp: `Ordenar la propiedad`,
applyFilters: `Aplicar filtros`,
selectSetType: `¿Qué quieres practicar?`,
getStarted: `Empezar`,
tapToUnarchive: `Toque en las tarjetas que desea no ser solicitadas.`,
untitled: `Intitulado`,
sortHintNew: `Verás las cartas que fueron creadas hace mucho tiempo primero.`,
sortHintDue: `Verá tarjetas que hayan sido vencidas por el primero más largo.`,
sortHintOther: `Verás tarjetas que no se han estudiado el primero más largo.`,
flashcardsWhen: `, para cuando está trabajando, y solo quiero echar un vistazo a sus tarjetas de reproducción automática`,
notificationsWhen: `, porque cuando estás fuera y solo quieres bits de estudio rápido.`,
quizWhen: `, porque cuando puedes pagar toda la atención para estudiar, dominar tus tarjetas.`,
features: `Características`,
ratings: `Calificaciones`,
notificationDailyCatchUpBody: `Nuevo: __, debido: ___, estudiando: ____, aprendido: _____, dominado: ______`,
notificationDailyCatchUpTitle: `Captura diaria`,
reviewedJN: `Revisado justo ahora`,
customUpdated: `Texto personalizado actualizado`,
customTextField: `Sinónimos, ejemplos, etc.`,
field: `Campo`,
link: `Enlace`,
backToParentCard: `Volver a la tarjeta principal`,
discard: `Descarte`,
failedImageLoad: `Error al cargar la imagen, asegúrese de estar conectado a Internet`,
printDIYLabel: `DIY su propia configuración de estudio basada en papel creativa, comparta con nosotros su creación y aparezca en la aplicación.`,
reviewGraphChart: `Gráfico de revisión`,
langNotSet: `Idioma no establecido`,
pronouncationLangInfo: `Para habilitar la pronunciación, debe seleccionar el término y la definición del idioma. Aparecerá un signo de altavoz junto a los idiomas si su dispositivo admite ese idioma`,
clearFilters: `Filtro claro`,
subFreeUnlimited: `Estudios ilimitados, tarjetas de flash, prácticas, búsqueda y sincronización.`,
customFields: `Campos Personalizados`,
subLinks: `Enlaces de tarjetas`,
subPrint: `Imprimir / StudySet`,
subNotifications: `Notificación antes de tener que abrir la aplicación`,
subCardsStudysets: `Tarjetas / StudySet`,
subRevisionCycles: `Ciclos de revisión personalizada`,
subscriptionHEnd: `La actualización a Pro muestra que encuentre nuestro trabajo duro valioso y nos da ánimo y café para seguir mejorando y creando nuevas cosas increíbles.`,
subFree: `Gratis`,
subPro: `Pro`,
guideSpacedRepetition: `¿Cómo funciona la repetición espaciada y los tipos de práctica?`,
guideSearch: `Búsqueda y filtrado`,
guideSync: `Habilitar copia de seguridad y sincronización a través de sus dispositivos`,
guidePronunciation: `Habilitar pronunciaciones`,
guideImport: `Importando tarjetas de las fuentes salidas.`,
guideAccess: `¿Quién tiene acceso a mis datos?`,
guideData: `¿Qué datos recogemos?`,
guideContact: `¿Necesitas ayuda con cualquier otra cosa? Escríbenos`,
arrowStrength: `Establece lo bien que sabes esta tarjeta`,
arrowImage: `Añadir imágenes`,
arrowField: `Añadir campos de texto personalizados adicionales`,
arrowTag: `Adjuntar etiquetas`,
arrowStar: `Marcar como favorito`,
arrowLink: `Enlace a otras tarjetas`,
arrowGoal: `Configurar un objetivo de revisión diario para ti mismo`,
arrowDue: `Estudiar las palabras que deben ser revisadas.`,
arrowNew: `Tarjetas de estudio que aún no han sido revisadas.`,
arrowMastered: `Si no tiene tarjetas de vencimiento o nuevas, puede revisar las tarjetas dominarlas para mantenerlas dominadas`,
arrowImport: `Importar sus flashcards existentes`,
arrowNewCard: `Añadir un nuevo flashcards`,
dropboxStep1: `1. Obtenga código de acceso desde Dropbox iniciando sesión`,
dropboxStep1Btn: `Inicia sesión con Dropbox`,
dropboxStep2: `2. Ingrese el código de acceso a continuación`,
dropboxStep2Input: `Ingresa el código aquí`,
dropboxStep3: `3. Iniciar sincronización`,
alreadyLinked: `Ya vinculado, toque para desvincular`,
selectCardsToLink: `Selecciona tarjetas para enlazar`,
unsupportedLangP: `Seleccione un idioma que admita la pronunciación de la configuración del conjunto`,
links: `Enlaces`,
emailUs: `Enviar correo electrónico`,
whatsappUs: `WhatsApp`,
printMinHeight: `Min. altura de la fila`,
exportType: `Tipo de archivo de exportación`,
generateFileText: `Generar archivo`,
generatatingFile: `Archivo generador`,
verySmall: `Muy pequeña`,
small: `Pequeña`,
normal: `Normal`,
big: `Grande`,
veryBig: `Muy grande`,
repeatNTimes: `Repetir __ veces`,
pause: `Pausa`,
for: `por`,
say: `Decir`,
defShort: `Defin.`,
times: `veces`,
autoplayPreferences: `Establecer las preferencias de la reproducción automática`,
autoPlay1: `Pausa después de la palabra anterior`,
autoPlay2: `Número de pronunciaciones a plazo`,
autoPlay3: `Pausa antes de revelar definición`,
autoPlay4: `Número de pronunciaciones de definición`,
autoPlay5: `Pausa antes de mostrar la siguiente palabra`,
autoPlay6: `Repite la misma flashcard`,
startAutoPlay: `Iniciar la reproducción automática`,
autoPlayOffConfirm: `Apague la función de reproducción automática para habilitar los controles manuales`,
turnOff: `Apagar`,
keepPn: `Continuar`,
foundIn: `Encontrado en __`,
repeat: `repetir`,
stop: `Detener`,
listenInBreak: `Escuchar música / podcasts en descansos`,
contextSearch: `Buscar contexto`,
contextSearchText: `Obtenga ejemplos de cómo __ se utilizan en diferentes oraciones`,
transalteSearch: `Traducir`,
translateSearchText: `Traducir __ 2 a ___`,
synonymSearch: `Buscar sinónimos`,
synonymSearchText: `Buscar Sinónimos de __`,
selectToAdd: `Seleccione los resultados que desea agregar a esta tarjeta.`,
addToCard: `Añadir seleccionado a la tarjeta`,
hideFromPractice: `No se muestres en esta ronda`,
setLanguageRequired: `Seleccione el idioma de los Términos y Definiciones en los detalles del StudySet`,
fieldNeedsText: `Ingrese algo en este campo antes de buscar`,
possibleDupe: `Posible duplicado`,
loadNextXCards: `Cargar tarjetas Siguientes __`,
repeatPractice: `Repita estas tarjetas __`,
keepScreenOnInfo: `Es posible que tenga que ajustar su configuración de bloqueo automático, para mantener la pantalla encendida mientras la reproducción automática.`,
siteLoginH2: `Cuenta de SFM`,
siteLoginP: `Puede usar su cuenta de Flashcards made Simple para compartir sus flashcards con sus amigos, a sus estudiantes o a toda la comunidad.`,
logOut: `Cerrar sesión`,
logIn: `Iniciar sesión`,
createAccount: `Crear una nueva cuenta`,
signUp: `Inscribirse`,
username: `Nombre de usuario`,
email: `Correo electrónico`,
password: `Contraseña`,
networkError: `Error de red`,
fillAllDetails: `Por favor complete todos los detalles`,
noUserWithDetails: `Ningún usuario encontrado con los detalles ingresados`,
userAlreadyExists: `El correo electrónico dado o el nombre de usuario ya existe.`,
signUpOrLoginToCont: `¿Registrarse o iniciar sesión para continuar?`,
atLeastOneCardToShare: `Al menos una tarjeta es necesaria para compartir`,
publishingStudyset: `Publicado`,
updatesDetected: `Actualizaciones detectadas, ¿desea continuar actualizando los datos locales? (Eliminado: __, actualizado: ___, nuevo: ____)`,
updatesApplied: `Actualizaciones aplicadas`,
alreadyUpToDate: `Ya está actualizado`,
practiceTypeArrow: `Descubre diferentes formas de practicar.`,
share: `Cuota`,
sharingModalIntro: `Comparta sus flashcards en este conjunto con sus amigos, sus estudiantes o toda la comunidad.`,
whatIsShared: `Lo que se comparte`,
whatIsNotShared: `Lo que no se comparte`,
whatIsSharedText: `Establecer nombre, ajuste el lenguaje a plazo, el idioma de definición, todas las tarjetas incluidas con los términos, definiciones, campos de texto personalizados e imágenes`,
whatIsNotSharedText: `Cualquier fortaleza de tarjetas, estrellas, enlaces, etiquetas y su historial de revisión.`,
checkForSharedUpdates: `Compruebe las actualizaciones de Creator`,
fetchUpdates: `Fetch actualizaciones`,
youSharedStudyset: `Compartiste este estudiante`,
publishChanges: `Guardar y publicar cambios`,
redeem: `Redimir`,
noAds: `Sin anuncios`,
dupeDetection: `Detección duplicada`,
coffeeFeature: `Café, para ayudarnos a desarrollar más características.`,
shareLink: `Enlace compartir`,
coffeeForUs: `Obtendrá una licencia de por vida por solo __, lo que le da a Emily 6 Caffes, Dominik 3 Caffes y Russ 3 Caffes, que nos impulsará durante aproximadamente 39 horas para hacer que el evento de SFM sea mejor`,
sharingCards: `Tarjetas compartidas`,
published: `Publicado`,
alreadyHaveAccount: `¿Ya tienes una cuenta?`,
notAlreadyHaveAccount: `¿Ya no tienes una cuenta?`,
startPractice: `Iniciar la práctica`,
selectQuizTypes: `Seleccione tipos de prueba`,
correct: `Correcto`,
incorrect: `Incorrecto`,
yes: `Sí`,
no: `No`,
levelSilver: `Nivel de plata __`,
levelGold: `Nivel de oro __`,
levelPlatinum: `Nivel de platino __`,
levelDiamond: `Nivel de diamante __`,
levelJade: `Nivel de jade __`,
reviewsLeftGoal: `__ opiniones para la meta diaria`,
dailyGoalAchieved: `Objetivo diario logrado`,
share: `Cuota`,
rateApp: `Calificar aplicacion`,
allStats: `Todas las estadísticas`,
reviewTimeError: `Tiempo de espera después del error`,
reviewTimeCorrect: `Tiempo de espera después de lo correcto`,
pronounceTermAfterReview: `Pronuncia término después de la revisión`,
pronounceDefinitionAfterReview: `Pronuncia definición después de la revisión`,
practice: `Práctica`,
notificationsScheduledInfo: `Las notificaciones de __ se han programado, puede cerrar la aplicación ahora`,
wellDone: `Bien hecho`,
keepItUp: `Seguid así`,
youRock: `Tú Molas`,
niceOne: `Bonita`,
lnSelect: `Seleccione el idioma`,
sampleData: `No hay revisiones, mostrando datos de muestra.`,
reviewFreq: `Revisión Frecuencia`,
selectPractice: `Práctica: Seleccione`,
spellPractice: `Práctica: Hechizo`,
connectPractice: `Práctica: Conectar`,
languages: `Idiomas`,
languagesPairs: `Pares de idiomas`,
shareArrow: `Compra con amigos, estudiantes o toda la comunidad`,
cardsPerRound: `Tarjetas / redondo`,
showAll: `Mostrar todo`,
supportedLangsVary: `Los idiomas soportados varían`,
practiceWithoutSave: `Practicar no salvado`,
practiceWithoutSaveBody: `No ha agregado este StudySet a su colección, ¿desea agregarlo ahora para guardar el progreso de su estudio?`,
saveSetNow: `Guardar tarjetas para su colección`,
continueWithoutSaveSave: `Empezar la práctica sin guardar.`,
createdBy: `Creado por`,
setSavedToYourCollection: `Salvado`,
accountBackupDisclaimer: `Tenga en cuenta que esta cuenta solo se puede utilizar para compartir estudiosos con otros, y no se puede utilizar para realizar una copia de seguridad o sincronización de sus estudiosos o flashcards. Para sincronizar y hacer una copia de seguridad de todos sus datos, use Dropbox Sync`,
syncEnabled: `Sincronización habilitada, obteniendo su contenido en progreso`,
searchAllSets: `Buscar de otros usuarios`,
anyLanguage: `Cualquier idioma`,
trendingIn: `Tendencias en`,
manualBackups: `Copia de seguridad manual`,
manualBackupCreate: `Crear copia de seguridad manual`,
confirmManualImport: `¿Está seguro de que desea reemplazar todos los datos actuales con esta copia de seguridad? Esto solo se recomienda en nuevos dispositivos sin datos.`,
importFromManualBackup: `Importar desde la copia de seguridad`,
imgOfflineSets: `Imágenes de descarga automática para el aprendizaje fuera de línea`,
unsupportedDeviceCache: `Esta característica solo está disponible en la aplicación iOS o Android`,
shareChanges: `Compartir __ Cambios`,
publiclySearchable: `Búsqueda de usuarios`,
description: `Descripción`,
restoreFromDropboxBackup: `Restaurar desde Dropbox Backup`,
imageCacheStudysetSub: `[IOS & Android solo] Descargar imagen para estudiar fuera de línea`,
keywordsOrLangNeeded: `Tienes que ingresar algunas palabras clave o un idioma`,
dropboxAlreadyLinked: `La cuenta de Dropbox ya está vinculada`,
noSetUpdateAccess: `No tiene acceso para editar este conjunto de estudio.`,
confirmSetOwnerLogin: `Si está seguro de que es el propietario, intente iniciar sesión nuevamente en su cuenta.`,
uninitedRestriction: `To save your progress, first you have to add this studyset to your collection`,
getStartedHere: `Get Started Here`,
downloadFromAppStore: `Download From AppStore`,
downloadFromGooglePlay: `Download From GooglePlay`,
consolidateStorageError: `No se pudo consolidar el almacenamiento`,
consolidateStorageDone: `Consolidar de almacenamiento, permita hasta una hora para que Dropbox termine de eliminar archivos antiguos antes de iniciar sesión en un nuevo dispositivo.`,
consolidatingStorage: `Consolidación de almacenamiento ...`,
deleteAccount: `Borrar cuenta`,
consolidateStorageDescription: `Esta operación reinceará sus archivos de copias de seguridad, por lo que configurar un nuevo dispositivo será más rápido.`,
consolidatingStorageConfirm: `Asegúrese de que todos sus cambios ya hayan terminado de sincronizar, no sincronizar otros dispositivos mientras se realiza este proceso. ¿Quieres continuar?`,
consolidateStorage: `Consolidar almacenamiento`,


}